import TargetApplicationForm from './TargetApplicationForm';

export default TargetApplicationForm;
